import { DATAQUALITY } from "../../constants/action-types";
const initialState = {
    overallDbQualityScore: [],
    dataQualityScoreByFirstSource: [],
    dataQualityDataTable: [],
    cassReport: [],
    emailsWIthMultipleLTGIds: [],
    phoneNumbersWIthMultipleLTGIds: [],
    postalAddressWIthMultipleLTGIds: [],
    top10CustomersDataTable: [],
    top10CustomersDataTableTab: ""
}

const DataQualityReducer = (state = initialState, action) => {
    switch (action.type) {
        case DATAQUALITY.UPDATE_TOP_10_CUSTOMERS_TAB: {
            return Object.assign({}, state, {
                top10CustomersDataTableTab: action.payload
            });

        }
        case DATAQUALITY.UPDATE_TOP_10_CUSTOMERS_DATA_TABLE: {
            return Object.assign({}, state, {
                top10CustomersDataTable: action.payload
            });

        }
        case DATAQUALITY.UPDATE_POSTAL_MULTIPLE_LTGIDS_DATA_TABLE: {
            return Object.assign({}, state, {
                postalAddressWIthMultipleLTGIds: action.payload
            });

        }
        case DATAQUALITY.UPDATE_PHONE_MULTIPLE_LTGIDS_DATA_TABLE: {
            return Object.assign({}, state, {
                phoneNumbersWIthMultipleLTGIds: action.payload
            });

        }
        case DATAQUALITY.UPDATE_EMAIL_MULTIPLE_LTGIDS_DATA_TABLE: {
            return Object.assign({}, state, {
                emailsWIthMultipleLTGIds: action.payload
            });

        }
        case DATAQUALITY.UPDATE_OVERALL_DB_QUALITY_SCORE_DATA: {
            return Object.assign({}, state, {
                overallDbQualityScore: action.payload
            });

        }
        case DATAQUALITY.UPDATE_DB_QUALITY_BY_FIRST_SCORE_DATA: {
            return Object.assign({}, state, {
                dataQualityScoreByFirstSource: action.payload
            });

        }
        case DATAQUALITY.UPDATE_DATA_QUALITY_DATA_TABLE: {
            return Object.assign({}, state, {
                dataQualityDataTable: action.payload
            });

        }
        case DATAQUALITY.UPDATE_CASS_REPORT_DATA_TABLE: {
            return Object.assign({}, state, {
                cassReport: action.payload
            });

        }

        default:
            return state
    }

}

export default DataQualityReducer